<!--
 * @Descripttion: 
 * @Version: 1.0
 * @Author: pj
 * @Date: 2022-11-13 15:06:47
 * @LastEditors: pj
 * @LastEditTime: 2022-12-07 10:53:08
-->
<template>
    <div id="footer" class="container-fluid">
        <!-- <img src="@/assets/img/wx.jpg" alt="wxCode" style="width: 200px;position: relative;float: right;"> -->
        <div class="logo">
            <img src="@/assets/img/LOGO.png" alt="logo">
        </div>
        <p class="title">温州友创机械有限公司</p>
        <p class="address_tel_fax">
            <span>浙江省·温州市·瓯海区 </span>
            <span>&nbsp;&nbsp;TEL:135-8744-3369</span>
            <span>&nbsp;&nbsp;FAX:0577-65214396</span>
        </p>
        <p class="email_wx">
            <span>邮箱:<a href="mailto:langetechco@163.com" class="email" style="">&nbsp;langetechco@163.com</a></span>
            <span>&nbsp;&nbsp;&nbsp;微信号:&nbsp;&nbsp;<a class="email">WENZHOU_LOG</a></span>
        </p>
        <div class="wxCode" style="width: 230px;margin: 0 auto;">
            <img alt="" src="../../static/wxCode.jpg" style="width: 220px; height: 200px;" />
        </div>
        <p class="copy">Copyright &copy; 温州友创机械有限公司</p>
        <div style="padding-bottom:20px">
            <a href="https://beian.miit.gov.cn/" target="_blank" style="display: inline-block;text-decoration: none;height: 20px;line-height: 20px;">
                <img alt="" src="https://www.logge.com.cn/uploads/790_t_WNo_65d70.png" style="width: 20px; height: 20px;float: left;">
                <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#828282;">
                    浙ICP备2022018762号-1</p>
            </a>
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33030402001227" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
                <img alt="" src="../assets/img/031e4f2c10dcbbb64f31650dd97d9506.png" style="width: 20px; height: 20px;float: left;" />
                <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#828282;">浙公网安备
                    33030402001227号</p>
            </a>
        </div>

    </div>
</template>
<script>
export default {
    name: 'Footer',
    data() {
        return {}
    },
}
</script>
<style scoped>
.email {
    color: white;
    font-size: 12px;
    font-weight: bold;
    text-decoration: none;
}
#footer {
    width: 100%;
    height: 100%;
    color: #fff;
    background: #474747;
    overflow: hidden;
    text-align: center;
}
.logo {
    height: 130px;
    margin: 0px auto;
    margin-top: -60px;
}
.logo img {
    width: 200px;
    margin: 10px auto 10px;
}
.title {
    font-size: 25px;
    margin-bottom: 20px;
}
.address_tel_fax {
    color: #d3d3d3;
    font-size: 14px;
    margin: 10px 0;
}
.email_wx {
    color: #d3d3d3;
    font-size: 14px;
}
.copy {
    color: #d3d3d3;
    font-size: 14px;
    margin: 10px 0 10px;
}
@media screen and (max-width: 997px) {
    .title {
        font-size: 20px;
    }
    .address_tel_fax {
        font-size: 12px;
    }
    .email_wx {
        font-size: 12px;
    }
    .copy {
        font-size: 12px;
        margin: 10px 0 10px;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue